import { BaseLayout } from "../../../layouts/BaseLayout";
import DxmlDocument from "./Dxml/DxmlDocument";
import AttachmentTable from "../../WebEditorAttachment/attachmentTable";
import * as Constants from "../../../utils/constants";

/**
 * @param {Object}  props
 * @param {string?}  props.nav - The menu item to be highlighted. In most cases this should not be set.
 */

export const WebEditorDesign = ({ nav }) => {

    return (
        <BaseLayout nav={nav}>
            {
                nav === Constants.menuState.edit ?
                    <div className="sm:tw-min-h-full print:tw-my-0 print:tw-min-h-screen tw-bg-white tw-h-full">
                        <div className="tw-max-w-screen-xl xl:tw-max-w-screen-2xl tw-mx-auto tw-inset-0 ">
                            <div className="tw-flex tw-flex-col">
                                <div className="tw-max-w-screen-xl xl:tw-max-w-screen-2xl">
                                    <div className="tw-h-full">
                                        <div className="tw-container tw-max-w-screen-md tw-mx-auto tw-p-10 tw-flex tw-flex-col">
                                            <DxmlDocument></DxmlDocument>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <AttachmentTable />
            }
        </BaseLayout>
    )
}